module.exports = __webpack_public_path__ + "img/labBg1.ba459944.png";